module.exports = __webpack_public_path__ + "static/img/ARCHER-DAY-WICKS.986a3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHER-DAY-WICKS.jpg
// module id = HlUr
// module chunks = 0